// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".weekday[data-v-5e7ed8dc]{padding:.75em;margin-left:.2em;margin-bottom:.5em;cursor:pointer}", ""]);
// Exports
module.exports = exports;
